import React, { useContext, useRef, useState } from 'react'
import './Extracontents.css'
import Anydesk from "../../imgs/anydesk.png";
import Teamviewer from "../../imgs/Teamviewer.png";
import App from "../../imgs/app.webp";
import Password from "../../imgs/password.png";
import Mobileuser from "../../imgs/mobileuser.png";
import Settings2 from "../../imgs/settings.png";

import Box from '../Box/Box';
import Dialog from '../Dialog/Dialog';
import Globalcontext from '../../Context/Globalcontext';

import MobileUserr from '../Mobileuser/Mobileuser';
import Settings from '../Settings2/Settings2';

import { useTranslation } from "react-i18next";

const Extracontents = (props) => {
  const [mastermenu, setMastermenu] = useState(true);
  const [showBackImage, setShowBackImage] = useState(false);
  const [transitionEnded, setTransitionEnded] = useState(true);
  const [kopen, setkopen] = useState(0);

  const { submenu, setsubmenu, setHeadname } = useContext(Globalcontext);

  const [dialog, setDialog] = useState({
    message: "",
    isLoading: false,
    nameProduct: ""
  });

  const [t] = useTranslation();

  const areUSure = () => {
    handleDialog("", false);
  };

  const openkendra = () => {
    setShowBackImage(true);
    setMastermenu(false);
    setTransitionEnded(true);
    setsubmenu("kendra");
    setkopen(1);
  }

  const handleDialog = (message, isLoading, nameProduct) => {
    setDialog({ message, isLoading, nameProduct });
  };

  // For screens which should open inside same page (Settings, Mobile User)
  const visibility = () => {
    localStorage.setItem("glcustsr", "");
    setTransitionEnded(false);
    setMastermenu(!mastermenu);
    setkopen(0);
    setsubmenu("");
    setHeadname(t("head.extra"));
  }

  // For links (Anydesk/Teamviewer/AppSettings/ChangePass) -> Box will handle open modal / open link
  const visibility2 = () => {
    localStorage.setItem("glcustsr", "");
    setkopen(0);
    setsubmenu("");
    setHeadname(t("head.extra"));
  }

  const handleTransitionEnd = () => {
    if (!mastermenu) setShowBackImage(true);
    else setShowBackImage(false);
    setTransitionEnded(true);
  };

  return (
    <>
      <div className='line' />
      <div className="maincon">
        <div className="rowreport">
          <div className="mainconreport">
            <span className={`heading1 ${mastermenu ? '' : 'hidden'}`}>
              {t("extra.title")}
            </span>

            <div className={`Dashcontents ${mastermenu ? '' : 'hidden'}`} onTransitionEnd={handleTransitionEnd}>
              <Box
                action="anydesk"
                setsubmenu={setsubmenu}
                visibility={visibility2}
                background={"linear-gradient(179deg, var(--t1dark), var(--t1dark))"}
                head={t("Anydesk")}
                img={<img src={Anydesk} alt="" />}
              />

              <Box
                action="teamviewer"
                setsubmenu={setsubmenu}
                visibility={visibility2}
                background={"linear-gradient(179deg, var(--t6dark), var(--t6dark))"}
                head={t("extra.boxes.teamviewer")}
                img={<img src={Teamviewer} alt="" />}
              />

              <Box
                action="appsettings"
                setsubmenu={setsubmenu}
                visibility={visibility2}
                background={"linear-gradient(179deg, var(--t5dark), var(--t5dark))"}
                head={t("extra.boxes.mobile_app_settings")}
                img={<img src={App} alt="" />}
              />

              <Box
                action="changepass"
                setsubmenu={setsubmenu}
                visibility={visibility2}
                background={"linear-gradient(179deg, var(--t2dark), var(--t2dark))"}
                head={t("extra.boxes.change_password")}
                img={<img src={Password} alt="" />}
              />

              <Box
                action="settings"
                setsubmenu={setsubmenu}
                visibility={visibility}
                background={"linear-gradient(179deg, var(--t4dark), var(--t4dark))"}
                head={t("extra.boxes.settings")}
                img={<img src={Settings2} alt="" />}
              />

              <Box
                action="mobileuser"
                setsubmenu={setsubmenu}
                visibility={visibility}
                background={"linear-gradient(179deg, var(--t3dark), var(--t3dark))"}
                head={t("extra.boxes.mobile_user")}
                img={<img src={Mobileuser} alt="" />}
              />
            </div>
          </div>
        </div>

        <div className={`rowbox ${mastermenu ? '' : 'hidden'}`}>
          <div className="first"></div>
          <div className="second">
            <div className='line' />
            <span className='firstspan'>{t("extra.info.1")}</span>
            <span className='infospan'>{t("extra.info.2")}</span>
            <span className='infospan'>{t("extra.info.3")}</span>
            <span className='infospan'>{t("extra.info.4")}</span>
          </div>
        </div>

        <div className={`cust ${mastermenu ? 'hidden' : ''}`}>
          {transitionEnded && showBackImage && (
            submenu === "mobileuser"
              ? <MobileUserr setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} />
              : submenu === "settings"
                ? <Settings setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} />
                : ""
          )}
        </div>
      </div>

      {dialog.isLoading && (
        <Dialog
          submessage={dialog.nameProduct}
          onDialog={areUSure}
          message={dialog.message}
          functionname={openkendra}
          button1text={t("dialog.no")}
          button2text={t("dialog.yes")}
        />
      )}
    </>
  )
}

export default Extracontents
